import React from 'react';
import styled from 'styled-components';
import theme from '../../styles/theme';

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: ${theme.colors.background};
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  
  /* Prevent rubber band scrolling on iOS */
  overscroll-behavior: none;
  
  /* Ensure full viewport height on mobile */
  min-height: -webkit-fill-available;
  min-height: 100vh;
  
  /* Mobile-specific viewport improvements */
  @media screen and (max-width: ${theme.breakpoints.tablet}) {
    /* Use fixed positioning to prevent keyboard issues */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    min-height: 100vh;
    min-height: -webkit-fill-available; /* Fallback for older iOS */
    
    /* Ensure proper scrolling behavior */
    overflow-y: auto; /* Allow scrolling on mobile */
    -webkit-overflow-scrolling: touch;
    
    /* Prevent zoom on input focus (iOS) */
    input, select, textarea {
      font-size: 16px;
    }
  }
`;

const Content = styled.main`
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const AppContainer = ({ children }) => {
  return (
    <Container>
      <Content>
        {children}
      </Content>
    </Container>
  );
};

export default AppContainer; 